import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AppComponent } from "src/app/app.component";
import {
  SystemDefaultModel,
  ChineseDefaultModel,
  EnglishDefaultModel,
} from "src/app/models/non-master-model/SystemDefaultModel";
import { tConsultHeadModelWithPatientInfo } from "src/app/models/tConsultHeadModel";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";
import { isNullOrUndefined } from "util";
import {
  tConsultCertModel,
  tConsultCertModelPrint,
  tProcedureFeeModel,
} from "src/app/models/tConsultCertModel";
import { DateTimeConvertService } from "src/app/services/CommonService/DateTimeConvert.service";
import { tOnConsultService } from "src/app/services/tOnConsult.service";
import { tEmployeeService } from "src/app/services/tEmployee.service";
import { AppSettings } from "src/app/shared/AppSettings";
import { GenderModel } from "src/app/models/SimpleConfigModel";
import { tShopService } from "src/app/services/tShop.service";
import { tShopModel } from "src/app/Models/tShopModel";
@Component({
  selector: "app-procedure-fee",
  templateUrl: "./procedure-fee.component.html",
  styleUrls: ["./procedure-fee.component.css"],
})
export class ProcedureFeeComponent implements OnInit {
  isHiddenShop2Sign = false;
  isHiddenDefaultSign = false;

  // picFullPath = './assets/img/print/doc_logo.png';
  // picFullPath = window.location.origin + '/assets/img/print/doc_logo.png';
  urlStartingPath = AppSettings.shopAdapter.imagePath;
  picFullPath = `${this.urlStartingPath}/favicon.png`;
  signShop2Path = this.urlStartingPath + "/assets/img/print/signShop2.png";

  TAG = "ConsultCertComponent";

  isHiddenShop1Info = true;
  isHiddenShop2Info = true;
  shop : tShopModel;

  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;
  @Input() searchFilter: number;
  @Input() docType: number;
  @Input() genderList: GenderModel[];

  onConsultDataList: tConsultHeadModelWithPatientInfo;
  tProcedureData: tProcedureFeeModel;
  patientTitle_selection;
  patientGender_selection;

  printCertList: tConsultCertModelPrint;

  patientGender_selection_Display = "";

  showEng = false;
  employeeID;

  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
    private tOnConsultService: tOnConsultService,
    private dateTimeConvertService: DateTimeConvertService,
    private tEmployeeService: tEmployeeService,
    private OnConsultService: tOnConsultService,
    private tShopService: tShopService,
  ) {}

  ngOnInit() {
    this.getShopInfo(NavigationComponent.selectedShopID.toString());
    this.getGender();

    this.printCertList = new tConsultCertModelPrint();

    this.setDefaultLanguageString(AppComponent.usingLanguage);
    this.onConsultDataList = JSON.parse(localStorage.getItem("onConsultModel"));
    this.tProcedureData = JSON.parse(localStorage.getItem("tProcedureData"));
    this.getOnConsultInfo();

    if (NavigationComponent.selectedShopID.toString() === "2") {
      this.isHiddenShop2Sign = false;
      this.isHiddenDefaultSign = true;
    } else {
      this.isHiddenShop2Sign = true;
      this.isHiddenDefaultSign = false;
    }

    if (NavigationComponent.selectedShopID.toString() === "2") {
      this.isHiddenShop1Info = true;
      this.isHiddenShop2Info = false;
    } else {
      this.isHiddenShop1Info = false;
      this.isHiddenShop2Info = true;
    }
  }

  getShopInfo(shopID: string) {
    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        this.shop = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getOnConsultInfo() {
    // tslint:disable-next-line:max-line-length
    this.tOnConsultService
      .getOnConsultInfo(
        this.onConsultDataList.shopID,
        this.onConsultDataList.clthConsultNumber
      )
      .subscribe((data) => {
        // this.log.i(this.TAG + ' getOnConsultInfo: ', JSON.stringify(data));
        this.onConsultDataList = data[0];
        this.employeeID = data[0].clthTherapistID;
        this.tEmployeeService
          .getDataById(
            1, // NavigationComponent.selectedShopID,
            this.onConsultDataList.clthTherapistID.toString()
          )
          .subscribe((therapisdata) => {
            this.printCertList.employee_Chinese_name =
              therapisdata.employeeChiName;
            this.printCertList.employee_ENG_name =
              therapisdata.employeeFirstName;
            this.printCertList.regNo1 = therapisdata.drCMP;
            this.printCertList.regNo2 = therapisdata.drRegNo;

            if (this.printCertList.regNo2 !== "006712") {
              this.isHiddenShop2Sign = true;
            }
          });
        //this.patientGender_selection_Display = this.patientGender_selection[this.onConsultDataList.patientGender - 1].displayName;

        for (var i = 0; i < this.genderList.length; i++) {
          if (this.onConsultDataList.patientGender == this.genderList[i].id) {
            if (this.showEng == false) {
              this.patientGender_selection_Display =
                this.genderList[i].chineseName;
            } else {
              this.patientGender_selection_Display = this.genderList[i].engName;
            }
          }
        }
        this.getSavedConsultCert();
      });
  }

  getSavedConsultCert() {
    this.tOnConsultService
      .getSavedConsultCert(
        NavigationComponent.selectedShopID.toString(),
        this.onConsultDataList.clthConsultNumber,
        this.onConsultDataList.patientID
      )
      .subscribe((data: any) => {
        if (!isNullOrUndefined(data[0])) {
          // this.log.d(this.TAG, 'getSavedConsultCert: ' + JSON.stringify(data[0]));
          this.printCertList = data[0];

          const dbStartDate = this.dateTimeConvertService.ConvertCurrentDBDay(
            new Date(data[0]["startDate"].toString())
          );
          const dbEndDate = this.dateTimeConvertService.ConvertCurrentDBDay(
            new Date(data[0]["endDate"].toString())
          );

          const dbArrDate = this.dateTimeConvertService.ConvertCurrentDBDay(
            new Date(this.onConsultDataList.clthArrivalDateTime.toString())
          );

          this.printCertList.startDatePrint = dbStartDate;
          this.printCertList.endDatePrint = dbEndDate;
          this.printCertList.ArrivalDatePrint = dbArrDate;

          this.tEmployeeService
            .getDataById(
              1, // NavigationComponent.selectedShopID,
              this.onConsultDataList.clthTherapistID.toString()
            )
            .subscribe((therapisdata) => {
              this.printCertList.employee_Chinese_name =
                therapisdata.employeeChiName;
              this.printCertList.employee_ENG_name =
                therapisdata.employeeFirstName;
              this.printCertList.regNo1 = therapisdata.drCMP;
              this.printCertList.regNo2 = therapisdata.drRegNo;

              if (this.printCertList.regNo2 !== "006712") {
                this.isHiddenShop2Sign = true;
              }
            });
        }
      });
  }

  setDefaultLanguageString(language: String) {
    switch (language) {
      case SystemDefaultModel.Language_Chinese:
        this.showEng = false;
        break;
      case SystemDefaultModel.Language_English:
        this.showEng = true;

        break;
      default:
        this.showEng = false;

        break;
    }
  }

  cancel() {
    // this.log.i(this.TAG, "do cancel");
    this.activeModal.close("Close click");
  }

  changeFont(className: string, operator: string) {
    console.log("doing changeFont operator = " + operator);
    let element: any;
    //  let element2: any;

    element = document.getElementById(className);

    var style = window
      .getComputedStyle(element, null)
      .getPropertyValue("font-size");
    var fontSize = parseFloat(style);

    if (operator === "+") {
      element.style.fontSize = fontSize + 1 + "px";
    } else {
      element.style.fontSize = fontSize - 1 + "px";
    }
  }

  getGender() {
    console.log("do getGender");
  }
}
